export var SocialMediaPlatforms = /*#__PURE__*/ function(SocialMediaPlatforms) {
    SocialMediaPlatforms["Apple"] = "apple";
    SocialMediaPlatforms["Facebook"] = "facebook";
    SocialMediaPlatforms["Google"] = "google";
    SocialMediaPlatforms["VKontakte"] = "vkontakte";
    SocialMediaPlatforms["Wechat"] = "wechat";
    SocialMediaPlatforms["ActiveDirectory"] = "activedirectory";
    return SocialMediaPlatforms;
}({});
